export const modalVariants = {
    hidden: {
        opacity: 0,
        scale: 0.9,
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.3,
        },
    },
    exit: {
        opacity: 0,
        scale: 0.9,
        transition: {
            duration: 0.2,
        },
    },
};

export const container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.5
        }
    }
}

export const pageVariants = {
    hidden: {
        opacity: 0,
        x: -100,
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
    exit: {
        opacity: 0,
        x: 100,
        transition: {
            duration: 0.4,
            ease: "easeIn",
        },
    },
};

export const pageVariants1 = {
    hidden: {
        opacity: 0,
        scale: 0.98,
        zIndex: 1,
    },
    visible: {
        opacity: 1,
        scale: 1,
        zIndex: 1,
        transition: {
            duration: 0.4,
            ease: "easeOut",
        },
    },
    exit: {
        opacity: 0,
        scale: 0.98,
        zIndex: 1,
        transition: {
            duration: 0.3,
            ease: "easeIn",
        },
    },
};

export const variablesCard = {
    hidden: {
        opacity: 0,
        y: -100, // Moves from the top
    },
    visible: {
        opacity: 1,
        y: 0, // Moves to the center of the viewport
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
    exit: {
        opacity: 0,
        y: 100, // Moves downwards when exiting
        transition: {
            duration: 0.4,
            ease: "easeIn",
        },
    },
};